<template>
  <div class="recommend">
    <div class="title">
      <div class="first-title flex-c-c">
        <img class="icon" src="@/assets/images/5ggameicon.png" />
        <span>天翼云游戏，一点即玩</span>
      </div>
      <div class="second-title flex-c-c">
        无需下载 跨端体验
      </div>
    </div>
    <div
      class="norem-voice-position"
      v-if="sliderImg[sliderIndex].flag"
      @click="muteChange"
    >
      <img v-if="showMute" src="@/assets/images/muted.png" />
      <img v-else class="norem-voice" src="@/assets/images/voice.png" />
    </div>
    <div class="carousel" @mouseenter="stop()" @mouseleave="start()">
      <ul class="carousel-body">
        <li
          class="carousel-item"
          v-for="(item, i) in sliderImg"
          :key="i"
          :class="{ fade: sliderIndex === i }"
        >
          <video
            v-if="item.flag"
            id="officialPlayer"
            class="video-js"
            loop
            autoplay
            :poster="item.content"
            data-setup="{}"
            :src="item.content"
            muted
          >
            您的浏览器不支持 video 标签。
          </video>
          <img v-else-if="item.content" :src="item.content" alt="" />
        </li>
      </ul>
      <!-- 分页器 -->
      <div class="carousel-indicator" v-if="sliderImg.length > 1">
        <p
          v-for="(item, i) in sliderImg"
          :key="i"
          :class="{ active: sliderIndex === i }"
          @click="sliderIndex = i"
        ></p>
      </div>
    </div>
    <div class="download-wrapper flex-c-c up-bg">
      <div class="download">
        <div class="mobile-wrapper flex-c-sb">
          <div class="qrcode-hover flex-c-c" v-if="displayQrcode">
            <img class="qrcode-icon" src="@/assets/images/qrcode.png" />
          </div>
          <div class="norem-mobile-content flex-c-c" @click="apkDownload(1)">
            <img class="sign-mobile" src="@/assets/images/mobile.png" />
            <img
              class="tip"
              src="@/assets/images/qrcodeicon.png"
              @mouseover="show(1, true)"
              @mouseout="show(1, false)"
            />
            <div class="left-mobile">
              <div class="top font-large">移动端下载</div>
              <div class="font-smallest version">
                <span class="mr10">版本号：{{ mobileVersion }} </span>
                <span> 更新时间：{{ mobileUpdataTime }}</span>
              </div>
            </div>
          </div>
          <div class="font-smallest">
            支持Android/IOS操作系统的手机/平板等设备
          </div>
        </div>
        <div class="mobile-wrapper flex-c-sb">
          <div class="tv-hover" v-if="displayTvTip">
            <div class="tv-title">天翼云游戏TV端安装指引</div>
            <div class="flex-c-c">
              <div class="step">
                U盘安装方式（仅需<i class="red-num">3</i>步）
              </div>
              <img class="step-img" src="@/assets/images/step.png" />
            </div>
          </div>
          <div class="norem-mobile-content flex-c-c" @click="apkDownload(2)">
            <img class="sign-tv" src="@/assets/images/tv.png" />
            <img
              class="tip"
              src="@/assets/images/tip.png"
              @mouseover="show(2, true)"
              @mouseout="show(2, false)"
            />
            <div class="left">
              <div class="top font-large">TV端下载</div>
              <div class="font-smallest version">
                <span class="mr10">版本号：{{ tvVersion }} </span>
                <span> 更新时间：{{ tvUpdateTime }} </span>
              </div>
            </div>
          </div>
          <div class="font-smallest">
            支持Android操作系统的智能电视
          </div>
        </div>
        <div class="mobile-wrapper flex-c-sb">
          <div class="norem-mobile-content flex-c-c" @click="toH5">
            <img class="sign-web" src="@/assets/images/webicon.png" />
            <div class="left font-large">无需下载 立刻体验</div>
          </div>
          <div class="font-smallest">
            支持PC/MAC/手机/平板等通过浏览器打开
          </div>
        </div>
      </div>
    </div>
    <div class="download-cover"></div>
    <Footer></Footer>
  </div>
</template>

<!-- <script setup> -->
<script>
import { ref, reactive, onBeforeMount, onUnmounted } from "vue";
import "@/assets/font/font.css";
import Footer from "@/components/global/footer.vue";
import { getContentDetails, getTVVersion, getVersion } from "@/api/request";
export default {
  components: {
    Footer
  },
  data() {
    return {
      displayQrcode: false,
      displayTvTip: false,
      showMute: true
    };
  },
  setup() {
    // 轮播条件： autoPlay 为true
    const autoPlay = true;
    // 轮播间隔
    const duration = 8000;
    // 轮播图序号
    const sliderIndex = ref(0);
    // 移动端下载地址
    let pkgFile =
      "https://cdn.cloud.play.cn/cf/cloud/pkg/hf/000/031/389/52e365dh1def5ad0/cn.egame.terminal.cloud5g_4.4.2_00000000.apk";
    // TV端下载地址
    let tvApkUrl =
      "https://ctcdn.cloud.play.cn/cf/cloud/pkg/hf/000/075/316/0b81742h47d3ca6c/EgameTV_PB_2.7.00001_202208300216_openEnv_Release.apk";
    const mobileUpdataTime = ref("2022-09-16");
    const mobileVersion = ref("4.4.2");
    const tvUpdateTime = ref("2022-09-08");
    const tvVersion = ref("2.7.0");
    let timer = null;
    const sliderImg = reactive([
      {
        content: ""
      }
    ]);
    // 自动轮播
    const autoPlayFn = () => {
      clearInterval(timer);
      timer = setInterval(() => {
        sliderIndex.value++;
        if (sliderIndex.value >= sliderImg.length) {
          sliderIndex.value = 0;
        }
      }, duration);
    };
    const getImageVideo = () => {
      getContentDetails(39210).then(res => {
        if (res.data.code === 200 && res.data.ext.module_id) {
          //9532
          getContentDetails(res.data.ext.module_id).then(res1 => {
            if (res1.data.code === 200 && res1.data.ext.contents) {
              //7760
              res1.data.ext.contents.channel_content.forEach((item, i) => {
                if (i === 0) {
                  sliderImg[0] = {
                    content: item.open_video[0] || item.img_1080p[0],
                    flag: item.open_video[0] ? true : false
                  };
                } else if (item.open_video[0] || item.img_1080p[0]) {
                  sliderImg.push({
                    content: item.open_video[0] || item.img_1080p[0],
                    flag: item.open_video[0] ? true : false
                  });
                }
              });
              autoPlayFn();
            }
          });
        }
      });
    };

    // 鼠标进入停止轮播
    const stop = () => {
      if (timer) clearInterval(timer);
    };
    // 鼠标移出开启轮播
    const start = () => {
      if (sliderImg.length && autoPlay) {
        autoPlayFn();
      }
    };
    const getDownloadInfo = () => {
      getVersion().then(res => {
        if (res.data.code === 200 && res.data.ext) {
          mobileUpdataTime.value =
            res.data.ext.release_date.substring(0, 10) || "2022-09-16";
          mobileVersion.value = res.data.ext.title || "4.4.2";
          if (
            res.data.ext.pkg_file &&
            res.data.ext.pkg_file.substring(0, 5) !== "https"
          ) {
            pkgFile = res.data.ext.pkg_file.replace("http", "https");
          } else {
            pkgFile = res.data.ext.pkg_file;
          }
          // 将路径中的 /f/cloud 替换为 /cf/cloud
          if (pkgFile) {
            pkgFile = pkgFile.replace("/f/cloud", "/cf/cloud");
          }
        }
      });
      getTVVersion().then(res => {
        if (res.data.code === 0) {
          tvUpdateTime.value =
            res.data.ext.update_time.substring(0, 10) || "2022-12-07";
          tvVersion.value = res.data.ext.version_name || "2.7.0";
          if (
            res.data.ext.download_url &&
            res.data.ext.download_url.substring(0, 5) !== "https"
          ) {
            tvApkUrl = res.data.ext.download_url.replace("http", "https");
          } else {
            tvApkUrl = res.data.ext.download_url;
          }
          // 将路径中的 /f/cloud 替换为 /cf/cloud
          if (tvApkUrl) {
            tvApkUrl = tvApkUrl.replace("/f/cloud", "/cf/cloud");
          }
        }
      });
    };
    const apkDownload = i => {
      getDownloadInfo();
      if (i == 1) {
        window.open(pkgFile);
      } else {
        window.open(tvApkUrl);
      }
    };
    const judgeMobile = () => {
      const flag = navigator.userAgent.match(
        /(phone|iPhone|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      console.log(navigator.userAgent, flag, window.innerWidth);
      if (window.innerWidth < 500) {
        location.href = "https://h5.play.cn/h5";
      }
    };
    window.addEventListener("load", function() {
      window.addEventListener("resize", function() {
        judgeMobile();
      });
    });
    onBeforeMount(() => {
      judgeMobile();
      getImageVideo();
      getDownloadInfo();
    });
    // 组件消耗，清理定时器
    onUnmounted(() => {
      clearInterval(timer);
    });

    return {
      sliderIndex,
      sliderImg,
      mobileUpdataTime,
      mobileVersion,
      tvVersion,
      tvUpdateTime,
      stop,
      start,
      apkDownload
    };
  },
  methods: {
    show(i, flag) {
      if (i == 1) {
        // http://h5.play.cn/cdl
        this.displayQrcode = flag;
      }
      if (i == 2) {
        this.displayTvTip = flag;
      }
    },
    muteChange() {
      const videoPlayer = document.getElementById("officialPlayer");
      videoPlayer.muted = videoPlayer.muted ? false : true;
      this.showMute = videoPlayer.muted;
    },
    toH5() {
      let h5Url = "";
      if (h5Url) {
        h5Url.close();
      }
      h5Url = window.open("https://h5.play.cn/h5?caf=20000009", "_blank");
    }
  }
};
</script>
<style scoped lang="stylus">
.carousel {
  text-decoration: none;
  z-index: -1;
  .carousel {
    &-body {
      width: 100%;
      height: 100%;
    }
    &-item {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      list-style: none;
      transition: opacity 0.5s linear;
      &.fade {
        opacity: 1;
        z-index: 1;
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      img{
        width: 100%;
      }
    }
    &-indicator {
      position: absolute;
      top: 0;
      left: 32px;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 99;
      p {
        width: 12px;
        height: 12px;
        background: #fff;
        border-radius: 50%;
        cursor: pointer;
        ~ p {
          margin-top: 12px;
        }
        &:hover{
          width: 14px;
          height: 14px;
        }
        &.active {
          padding: 2px;
          width: 10px;
          height: 10px;
          background: #ff2850;
          border:2px solid  #ff2850;
          background-clip: content-box;
        }
      }
    }
  }
}
</style>

<style lang="stylus" scoped>
@keyframes turn {
  0% {
      transform: rotate(0deg);
  }

  60% {
      transform: rotate(216deg);
  }

  100% {
      transform: rotate(360deg);
  }
}
.up-bg
  z-index: 6;
.recommend
  padding:30px 70px;
  color: $color-white;
  background-color: #1E2023;
  font-family: 'SourceHanSansCN';
  overflow: scroll;
  .flex-c-sb
    layout-flex(center,space-between);
  .flex-c-c
    layout-flex(center,center);
    flex-direction: column;
  .font-smallest
    font-size: 12Px;
    color: rgba(255,255,255,0.8);
  .font-large
    font-size: 20Px;
  .red-num
    color: rgba(255, 40, 80, 1);
  .norem-voice-position
    position:absolute;
    top: 100px;
    right: 80px;
    cursor: pointer;
    z-index: 10;
    img
      width: 30Px;
      height: 30Px;
      opacity: 0.4;
    .norem-voice
      animation: turn 8s linear infinite;
  .title
    position: relative;
    margin: 150px 0;
    text-shadow: 1px 1px rgba(0, 0, 0, 0.3);
    z-index: 3;
    .first-title
      flex-direction: row;
      min-width: 300px;
      font-size: 70px;
      font-family: 'SourceHanSansCN-Normal';
      .icon
        width: 80px;
        height: 80px;
        margin-right: 20px;
    .second-title
      margin-top: 30px;
      min-width: 300px;
      font-size: 46px;
  .download-cover
    position:fixed;
    bottom: 0;
    left: 0;
    height: 35%;
    width: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
    z-index: 2;

  .download-wrapper
    position:absolute;
    left: 0;
    bottom: 150Px;
    width: 100%;
    z-index: 3;
    .download
      position:relative;
      layout-flex(flex-start,flex-start);
      margin-left: 80Px;
      .mobile-wrapper
        position: relative;
        flex-direction: column;
        margin: 0 9Px 18Px;
        overflow: visible;
        .tv-hover
          position: absolute;
          top: -493px;
          width: 840px;
          height: 450px;
          border: 1px solid rgba(255, 255, 255, 0.95);
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.95);
          z-index: 99;
          .step-img
            width: 602px;
            height: 130px;
            margin: 60px 0;
          .step
            margin: 0 auto;
            font-size: 20px;
            color: rgba(47, 100, 200, 1);
          .tv-title
            margin: 60px auto;
            font-size: 30px;
            font-weight: bold;
            color: #235BC5;
            text-align: center;
        .qrcode-hover
          position: absolute;
          top: -230Px;
          width: 197Px;
          z-index: 99;
          .qrcode-icon
            width: 197Px;
            height: 197Px;
        .norem-mobile-content
          position:relative;
          margin-bottom: 11px;
          width: 286px;
          height: 80px;
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 6px;
          background: rgba(255,255,255,0.2);
          backdrop-filter: saturate(180%) blur(20px);
          -webkit-backdrop-filter: blur(20px);
          cursor:pointer;
          .sign-mobile
            position: absolute;
            top: 21Px;
            left: 22Px;
            width: 29Px;
            height: 38Px;
          .sign-tv
            position: absolute;
            top: 22Px;
            left: 18Px;
            width: 43Px;
            height: 36Px;
          .sign-web
            position: absolute;
            top: 20Px;
            left: 20Px;
            width: 41Px;
            height: 37Px;
          .tip
            position: absolute;
            top: 17Px;
            right: 20Px;
            width: 20Px;
            height: 20Px;
            z-index: 6;
          .mr10
            margin-right: 10Px;
          .version
            color: rgba(255,255,255,0.6);
          .left
            position:absolute;
            left: 71Px;
            text-align: left;
          .left-mobile
            position:absolute;
            left: 61Px;
            text-align: left;
          .top
            position:relative;
            margin-bottom: 20Px;
        .norem-mobile-content:hover
          background: rgba(255,255,255,0.4);
          border: 1px solid rgba(255,255,255,0.4);
</style>
